import { Component } from '@angular/core';

import { AlertController, NavController } from 'ionic-angular';
import { ModalController, ViewController,NavParams } from 'ionic-angular';



import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { JobSelectForm } from '../../../utils/job-select/job-select';


import { UserData } from '../../../../providers/user-data';
import { UiData } from "../../../../providers/ui-data";
import { JobDataService } from '../../../../providers/job-data';

import {FormGroup, FormBuilder, FormControl, Validators} from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import {DocumentSelectForm} from "../../../utils/document-select/document-select";



@Component({
    selector: 'page-cvform',
    templateUrl: 'cvform.html'
})
export class CvAddForm {
    mode: string;
    introduction: string;
    object: any;
    ref: any;
    objectRef: any;
    form : FormGroup;
    formData: any;
    submitAttempt: boolean = false;
    modalTitle: string;

    languageList: any;
    languageLevelList: any;

    diplomaLevelsList: any;
    diplomaThemesList: any;
    durationRange: any;
    permisList: any;
    certificatesList: any;
    readOnlys:any = {};
    selectOptions:any;
    certificateObject:any = false;

    constructor(
        public viewCtrl: ViewController,
        public params: NavParams,
        public alertCtrl: AlertController,
        public nav: NavController,
        public userData: UserData,
        public uiData: UiData,
        public afDatabase: AngularFireDatabase,
        private formBuilder: FormBuilder,
        public modalCtrl: ModalController,
        public jobDataService: JobDataService
    ) {
        this.selectOptions = {
            /*title: 'Pizza Toppings',
            subTitle: 'Select your toppings',
            mode: 'md'*/
        };
        //userData.setToken('nova2');
        this.introduction=params.get('introduction');
        this.mode=params.get('mode');
        this.object=params.get('object');
        this.ref=params.get('ref');

        this.durationRange = uiData.getExperienceRanges();
        this.certificatesList = uiData.certificatesList();
        this.permisList = uiData.permisList();

        if(this.mode=="formations")
        {

            this.formData = {
                year: '',
                level: '',
                title: '',
                detail: "",
            };
            if(params.get('title')){this.formData.title=params.get('title');this.readOnlys['title']=true;}
            if(params.get('level')){this.formData.level=params.get('level');this.readOnlys['level']=true;}

            this.form = this.formBuilder.group({
                year: [null, Validators.required],
                level: [null, Validators.required],
                title: [null, [Validators.required,Validators.minLength(5)]],
            });

            this.modalTitle = "une formation";

            this.diplomaLevelsList = uiData.diplomaLevelsList();
            this.diplomaThemesList = uiData.diplomaThemesList();
        }
        else if(this.mode=="experiences")
        {
            this.form = this.formBuilder.group({
                year: [null, Validators.required],
                poste: [null, Validators.required],
                duree: [null, Validators.required],
                entreprise: [null, [Validators.required,Validators.minLength(3)]],
            });
            this.formData = {
                year: "",
                poste: "",
                detail: "",
                duree: "1 mois",
                entreprise: "",
            };
            if(params.get('job')){ this.formData.poste=params.get('job'); this.readOnlys['poste']=true; }
            if(params.get('duree')){ this.formData.duree=params.get('duree'); /*this.readOnlys['duree']=true;*/ }
            this.modalTitle = "une expérience";
        }
        else if(this.mode=="certificates")
        {
            this.form = this.formBuilder.group({
                type: [null, Validators.required],
                year: [null, Validators.required],
                certificate: [null, Validators.required],
                justificatif: [null,Validators.required],
                job: [null,Validators.required],
                /*justificatif: [null, function(){
                    var that = this;
                    console.log('CONTROLE');
                    return {'invalid':true};
                },function(){
                    var that = this;
                    console.log('CONTROLE A');
                    return {'invalid':true};
                } ],*/

            });
            this.formData = {
                type: "permis",
                year: "",
                certificate: "",
                detail: "",
                justificatif: '',
                job:null
            };
            var that = this;
            that.form.controls['certificate'].valueChanges.subscribe(function(certificateId){
                that.checkRequiredFields(certificateId);
            });
            that.checkRequiredFields(null);
            if(params.get('type')){this.formData.type=params.get('type');this.readOnlys['type']=true;}
            if(params.get('certificate')){this.formData.certificate=params.get('certificate');this.readOnlys['certificate']=true;}
            if(params.get('job')){this.formData.job=params.get('job');this.readOnlys['job']=true;}

            this.modalTitle = "un permis/certificat";
        }
        else if(this.mode=="languages")
        {
            this.form = this.formBuilder.group({
                //year: [null, Validators.required],
                langue: [null, Validators.required],
                level: [null, Validators.required],
            });
            this.formData = {
                langue: 'Français',
                level: ''
            };
            if(params.get('langue')){this.formData.langue=params.get('langue');this.readOnlys['langue']=true;}
            if(params.get('level')){this.formData.level=params.get('level');/*this.readOnlys['level']=true;*/}
            this.modalTitle = "une langue";

            this.languageList = uiData.languageList();
            this.languageLevelList = uiData.languageLevelList();
        }

        var that=this;
        if(this.object) // Update Form
        {
            this.userData.getToken().then(function(token){

                that.objectRef = that.afDatabase.object('/users/'+token+'/'+that.mode+'/'+that.object.key);
                that.objectRef.valueChanges().subscribe(data => {
                    that.formData = data;
                });
            });
            /*this.userData.load().subscribe(data => {
               that.formData = that.userData.get('formations/'+that.object.key);
            });*/
            this.modalTitle = "Modifier "+this.modalTitle;
        }
        else
        {
            this.userData.load().subscribe(data => {
            });
            this.modalTitle = "Ajouter "+this.modalTitle;
        }
    }
    checkRequiredFields(certificateId)
    {
        var that = this;
        if(that.formData.type == 'certificate' && certificateId)
        {
            that.certificateObject = that.uiData.getCertificateById(certificateId);
            if(that.certificateObject.document) {
                that.form.controls['justificatif'].enable();
            }
            else {
                that.form.controls['justificatif'].disable();
            }
            if(that.certificateObject.jobs) {
                that.form.controls['job'].enable();
            }
            else {

                that.form.controls['job'].disable();
            }
        }
        else if(that.formData.type == 'certificate')
        {
            that.form.controls['justificatif'].disable();
            that.form.controls['job'].disable();
        }
        else
        {
            if(that.formData.type == 'permis')
            {

                that.form.controls['justificatif'].enable();
                that.form.controls['job'].disable();
            }
        }
    }
    documentValidator(control: FormControl): {[s: string]: boolean} {


        if(!this || !this.formData) return null;

        //console.log(control.value);
        //console.log(this.formData.certificate);
        if (control.value && control.value.length < 15) {
            return {invalidJustificatif: true};
        }
    }
    addDocument(key)
    {
        var that = this;
        let documentSelectModal = this.modalCtrl.create(DocumentSelectForm, { document_type: 'certificate', id:key, multiple:true });
        documentSelectModal.onDidDismiss(data => {
            if(data && data.document_type)
            {

                this.formData.justificatif = data.url;
            }
            else
            {

            }
        });
        documentSelectModal.present();
    }
    saveItem() {
        this.submitAttempt=true;
        /* Todo : check controls */
        if(this.form.valid) {
            var that = this;
            let prompt = this.alertCtrl.create({
                title: 'Confirmation des informations',
                message: that.uiData.getDataValidationWarning(),
                buttons: [
                    {
                        text: 'Oui',
                        handler: data => {
                            if (that.object) {
                                that.objectRef.set(that.formData);
                                that.viewCtrl.dismiss({success:true});
                            }
                            else
                            {
                                /*var key = that.userData.push(that.mode,
                                    that.formData
                                );*/


                                 that.userData.getToken().then(function(token){

                                    if(that.mode == "experiences")
                                    {
                                        for(let i=0;i<that.durationRange.length;i++)
                                        {
                                            if(that.durationRange[i].label==that.formData.duree)
                                            {
                                                that.formData.duree_month=that.durationRange[i].data;
                                            }
                                        }
                                    }
                                     if(that.mode == "certificates")
                                     {
                                         var list;

                                         if(that.formData.type=="certificate")list = that.certificatesList;
                                         else list = that.permisList;

                                         for(let i=0;i<list.length;i++)
                                         {
                                             if(list[i]['id']==that.formData.certificate)
                                             {
                                                 that.formData.certificateName=list[i].name;
                                             }
                                         }
                                     }
                                    if(that.mode=="languages")
                                    {
                                        var key = that.formData.langue;
                                        that.formData.key = key;
                                        that.objectRef = that.afDatabase.object('/users/'+token+'/'+that.mode+'/'+key);
                                        that.objectRef.set(that.formData);
                                    }
                                    else {
                                        var key = that.ref.push(that.formData).getKey();
                                        that.objectRef = that.afDatabase.object('/users/'+token+'/'+that.mode+'/'+key+'/key');
                                        that.objectRef.set(key);
                                    }

                                });
                                that.viewCtrl.dismiss({success:true});
                            }
                        }
                    },
                    {
                        text: 'Annuler',
                        handler: data => {

                        }
                    }
                ]
            });
            prompt.present();

        }
        else
        {
            //console.log(this.form.value);
        }
    }
    ngAfterViewInit() {

    }
    chooseJob()
    {
        let jobSelectModal = this.modalCtrl.create(JobSelectForm, { mode: "certificates" });
        jobSelectModal.onDidDismiss(data => {
            if(data.success)
            {
                this.formData.poste = data.name;
            }
            else
            {

            }
        });
        jobSelectModal.present();
    }
    dismiss() {
        let data = { success:false };
        this.viewCtrl.dismiss(data);
    }

}


// WEBPACK FOOTER //
// ./src/pages/account/cv/form/cvform.ts